/**
 * @file
 * A JavaScript file containing the carousel functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.carouselVertical = {
    attach: function (context) {
      $(document).ready(function() {

        $('.carousel-hero__inner', context).once('carousel-processed').addClass('carousel-processed').each(function() {
          var options = $(this).data("carousel");

          tns({
            container: this,
            mode: "gallery",
            axis: "horizontal",
            loop: true,
            autoplay: true,
            autoplayButtonOutput: false,
            speed: 1000,
            mouseDrag: true,
            controls: true,
            controlsText: options.controlsText,
            navContainer: document.querySelector(".carousel-hero__nav")
          });
        });
      });
    }
  }
})(Drupal, jQuery);
